/* eslint-disable no-useless-escape */
import { JsonObject, JsonProperty } from "ta-json";
import URI from "urijs";

import Guard from "./guard";

@JsonObject()
export default class Link {
    @JsonProperty("href")
    href: string;

    @JsonProperty("title")
    title: string;

    @JsonProperty("templated")
    templated: boolean = false;

    constructor(uri: string | URI, title?: string, templated?: boolean) {
        if (typeof uri === "string") {
            this.href = uri;
        } else {
            this.href = uri.href();
        }

        if (title) {
            this.title = title;
        }

        this.templated = !!templated;
    }

    getVariableValue(template: Link, variable: string): string {
        Guard.notNullOrUndefined(template);
        Guard.stringNotNullOrEmpty(variable);
        Guard.stringNotNullOrEmpty(this.href);

        const templateUri = new URI(template.href);
        const currentUri = new URI(this.href);

        const index = templateUri
            .path()
            .split("/")
            .findIndex(item => item.startsWith(`{${variable}}`));

        if (index) {
            return decodeURIComponent(currentUri.path().split("/")[index]);
        }

        let queryRegexStr = `\?|,${variable.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")},|$`;
        let queryRegex = new RegExp(queryRegexStr);
        if (queryRegex.test(templateUri.query())) {
            queryRegexStr = `(?:^|&)${variable.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")}=([^#&]+)(?:[#&]?|$)`;
            queryRegex = new RegExp(queryRegexStr);
            const matches = queryRegex.exec(currentUri.query());
            if (matches) {
                return decodeURIComponent(matches[1]);
            }
        }

        throw `Variable '${variable}' not found in template '${template.href}'.`;
    }

    static copyFrom(source: Link): Link {
        return new Link(source.href, source.title, source.templated);
    }
}

export { Link };
